/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import EventEmitter from 'eventemitter3';

import Numeric from '../numeric/numeric';
import ScheduleInfo from './schedule-info';

/**
 * Strategie přehrávání pro prázdný obsah.
 * @implements {ScheduleStrategy}
 */
class ScheduleEmpty {
  /**
   * Vytvoří instanci.
   * @returns {ScheduleEmpty} Nová instance.
   */
  constructor() {
    /**
     * Správce událostí.
     * @private
     * @type {EventEmitter}
     */
    this.emitter = new EventEmitter();
  }

  /** @inheritdoc */
  destroy() {
    // Není potřeba nic rušit.
    // Přítomno pouze pro splnění rozhraní.
  }

  /** @inheritdoc */
  off(...args) {
    this.emitter.off(...args);
  }

  /** @inheritdoc */
  on(...args) {
    this.emitter.on(...args);
  }

  /** @inheritdoc */
  go() {
    const scheduleInfo = new ScheduleInfo();
    this.emitter.emit('gone', scheduleInfo);
    return scheduleInfo;
  }

  /** @inheritdoc */
  plan(offset) {
    if (!Numeric.isIndex(offset)) {
      throw new TypeError(`Invalid offset ${offset}.`);
    }
    return Array(offset)
      .fill()
      .map(() => new ScheduleInfo());
  }

  /** @inheritdoc */
  skip() {
    // Není potřeba nic přeskakovat.
    // Přítomno pouze pro splnění rozhraní.
  }

  /** @inheritdoc */
  stop() {
    // Není potřeba nic zastavovat.
    // Přítomno pouze pro splnění rozhraní.
  }

  /** @inheritdoc */
  toString() {
    return 'ScheduleEmpty';
  }
}

export default ScheduleEmpty;
